// General
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

// Redux Form
import { Field, reduxForm, formValueSelector } from 'redux-form';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import validate from './validate';

import { createAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';
import CommonFormComponent from '../../CommonField/CommonFormComponent';

import cp from '../../../components/commonStyle.css';
import s from './AdminUserForm.css';
import messages from '../../../locale/jsonMessages';
class AdminUserForm extends Component {

  static defaultProps = {
    roles: []
  };

  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }


  async handleFormSubmit(values) {
    const { createAdminUser, paginationData } = this.props;
    const response = await createAdminUser(
      values.id,
      values.email,
      values.password,
      Number(values.roleId)
    );
    if (response && response.status === 200) {
      paginationData(1);
    }
  }

  render() {
    const { error, handleSubmit, submitting, id, roles } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <form onSubmit={handleSubmit(this.handleFormSubmit)}>
        {error && <strong>{formatMessage(error)}</strong>}
        <div className="oneColumnGrid">
          <Field
            name="email"
            type="text"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.emailLabel)}
            labelText={formatMessage(messages.emailLabel)}
            inputClass='commonInputField'
            isRequiredInput
          />

          <Field
            name="password"
            type="password"
            component={CommonFormComponent}
            placeholder={formatMessage(messages.password)}
            labelText={formatMessage(messages.password)}
            inputClass='commonInputField'
            note={formatMessage(messages.adminUserDesc)}
            isRequiredInput={!id ? true : false}
          />

          <Field
            name="roleId"
            inputClass='commonSelectField'
            component={CommonFormComponent}
            labelText={formatMessage(messages.roleLabel)}
          >
            <option value={''}>{formatMessage(messages.selectRoleLabel)}</option>
            {
              roles && roles.results && roles.results.length > 0 && roles.results.map((item, key) => {
                return (
                  <option value={item.id} key={key}>{item.name}</option>
                )
              })
            }
          </Field>
        </div>
        <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
          <Button type="submit" disabled={submitting} className={cx(cp.btnPrimary)}>
            {id ? <FormattedMessage  {...messages.update} /> : <FormattedMessage  {...messages.addLabel} />}
          </Button>
        </div>
      </form>
    )
  }

}

AdminUserForm = reduxForm({
  form: "AdminUserForm", // a unique name for this form
  validate,
})(AdminUserForm);

const selector = formValueSelector('AdminUserForm');

const mapState = (state) => ({
  id: selector(state, 'id'),
});

const mapDispatch = {
  createAdminUser
};

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(AdminUserForm)));